var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkAccess('sales-by-sites'))?_c('report-list-page',{attrs:{"page-title":"Sales By Sites Report","page-icon":"mdi-sale","descending":true,"headers":_vm.headers,"state-end-point":"report.salesBySites","actions":_vm.actions,"show-component":_vm.showComponent,"item-key":"id"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }